import React from 'react';
import PropTypes from 'prop-types';
import SoilPresetChartSelect from './SoilPresetChartSelect';
import WeatherPresetChartSelect from './WeatherPresetChartSelect';

const PresetChartSelect = ({onSelectChange, preset, value}) => {
  const renderSelect = (preset) => {
    switch(preset){
      case 'soil': return <SoilPresetChartSelect onSelectChange={onSelectChange} value={value} />;
      case 'weather': return (
        <WeatherPresetChartSelect onSelectChange={onSelectChange} value={value} />
      );
      default: return <></>;
    }
  };

  return (
    <div id="presetChartSelect">
      {renderSelect(preset)}
    </div>

  );
};

PresetChartSelect.propTypes = {
  onSelectChange: PropTypes.func,
  preset: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
};

PresetChartSelect.defaultProps = {
  onSelectChange: () => null,
  preset: 'soil',
  value: undefined,
};

export default PresetChartSelect;
